export default __webpack_public_path__ + "static/media/PAFI_Pemanggilan RUPS 30 Juni 2025.abc4c18a.pdf";